import { REGISTER_WS, REGISTER_WS_SUCCESSFUL, REGISTER_WS_FAILED } from './actionTypes';

export const registerWorkstation = (ws, history) => {
    return {
        type: REGISTER_WS,
        payload: { ws, history }
    }
}

export const registerWorkstationSuccessful = (msg) => {
    return {
        type: REGISTER_WS_SUCCESSFUL,
        payload: msg
    }
}

export const registerWorkstationFailed = (msg) => {
    return {
        type: REGISTER_WS_FAILED,
        payload: msg
    }
}
